// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__Tpsmx","spinner":"Loading_spinner__4l-8Z"};